import React from 'react'
import { TileRoleRoute } from '@/types'
import { Roles } from '@/auth/azure/Roles'
import { faHammer } from '@fortawesome/free-solid-svg-icons'
import { ManagementGridFactory } from '@/routes/admin/components/ManagementGrid/ManagementGridFactory'
import { SupportPageRoute } from '@/routes/support/SupportPage.route'

export const SupportRoute: TileRoleRoute = {
  path: 'support',
  text: 'Supporto (Maintenance)',
  faIcon: faHammer,
  element: (
    <ManagementGridFactory
      entity="tipologia_assistenza"
      referencesCollection="assistenze"
      referencesTitle="Supporto (Maintenance)"
      displayField="ded_Dis"
      entityRoute={SupportPageRoute.path}
    />
  ),
  handle: {
    crumb: () => ({
      label: 'Supporto (Maintenance)',
      icon: faHammer,
    }),
  },
  mainMenuRoute: false,
  tile: true,
  allowedRoles: [Roles.GlobalAdministrator],
}
